import React from 'react';
import { Card } from 'semantic-ui-react';

const VocabularyTextCard = ({ vocabulary }) => (
  <Card.Description content={vocabulary.value} />
);

export default VocabularyTextCard;
